var render = function render(){var _vm=this,_c=_vm._self._c;return _c('popup-view',_vm._b({on:{"close":function($event){return _vm.$emit('close')}}},'popup-view',_vm.$attrs,false),[_c('clock-view',{attrs:{"value":_vm.value},on:{"input":_vm.input}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }